<!-- 图标列表 -->
<template>
  <div class="icon-list">
    <div class="icon-list-title" :class="isUpload ? 'upload-title' : ''">
      <span>{{ title }}</span>
      <span class="upload-edit" @click="editUpload" v-if="isUpload"
        >{{ isEdit ? "取消" : "" }}编辑</span
      >
    </div>
    <ul class="icon-list-content">
      <li
        v-if="isDefault"
        class="icon-list-content-item"
        :class="[
          type === 'iconly' ? 'iconly' : 'illustration',
          activeImg === 'default' ? 'active' : '',
        ]"
        @click="handleChangeValue('default')"
      >
        默认
        <ChooseIcon v-if="activeImg === 'default'"></ChooseIcon>
      </li>
      <li
        class="icon-list-content-item"
        :class="[
          type === 'iconly' ? 'iconly' : 'illustration',
          activeImg === item.url ? 'active' : '',
        ]"
        v-for="item in listComp"
        :key="item.url"
        @click="handleChangeValue(item.url)"
      >
        <template v-if="isUpload">
          <div
            class="upload-delete"
            v-if="isUpload && isEdit"
            @click.stop="delImg(item)"
          >
            <i class="iconfont icon-guanbi"></i>
          </div>
          <div class="upload-model" v-if="false">
            <div class="upload-tips">
              {{ isUpload ? "上传中" : "等待上传" }}
            </div>
            <el-progress :percentage="50" :show-text="false"></el-progress>
          </div>
        </template>
        <!-- <template v-if="color === 'default' || custom || !isColor">
          <el-image :src="handleSrc(item.url)"></el-image>
        </template>
        <template v-else>
          <div v-html="item.url" class="img-color"></div>
        </template> -->
        <el-image v-show="color === 'default' || custom || !isColor" :src="handleSrc(item.url)"></el-image>
        <div ref="svgImg" v-show="!(color === 'default' || custom || !isColor)" v-html="item.url" class="img-color"></div>
        <ChooseIcon v-if="activeImg === item.url"></ChooseIcon>
      </li>
    </ul>
  </div>
</template>

<script>
import ChooseIcon from './choose.vue'
import { convertImgToSvg } from '../config'

export default {
  name: 'iconList',
  components: {
    ChooseIcon
  },
  data () {
    return {
      active: false,
      isEdit: false,
      colorList: [],
      activeImg: 'default',
      isLoading: false
    }
  },
  props: {
    // 框体类型
    type: {
      type: String,
      default: 'iconly'
    },
    // 标题
    title: {
      type: String,
      default: '通用'
    },
    // 是否为上传
    isUpload: {
      type: Boolean,
      default: false
    },
    // 传过来的列表
    list: {
      type: Array,
      default: () => []
    },
    // 活跃的值
    activeValue: {
      type: String,
      default: ''
    },
    // 是否需要显示默认框
    isDefault: {
      type: Boolean,
      default: false
    },
    // 上传的颜色
    color: {
      type: String,
      default: 'defalut'
    },
    // 是否为自定义上传
    custom: {
      type: Boolean,
      default: false
    },
    isColor: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    hexify (color) {
      const values = color
        .replace(/rgba?\(/, '')
        .replace(/\)/, '')
        .replace(/[\s+]/g, '')
        .split(',')
      const a = parseFloat(values[3] || 1)
      const r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255)
      const g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255)
      const b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255)
      return ('0' + r.toString(16)).slice(-2) +
        ('0' + g.toString(16)).slice(-2) +
        ('0' + b.toString(16)).slice(-2)
    },
    delImg (item) {
      this.$emit('del', item)
    },
    editUpload () {
      this.isEdit = !this.isEdit
    },
    handleChangeValue (value) {
      let isBase = false
      if (this.isColor && this.color !== 'default' && !this.custom) {
        isBase = true
      }
      this.$emit('change', value, isBase)
      if (this.isColor) {
        this.$emit('isColor', true)
      } else {
        this.$emit('isColor', false)
      }
    },
    handleSrc (item) {
      if (this.color === 'default' || this.custom || !this.isColor) {
        return this.$imgurl + '/' + item
      } else {
        return item
      }
    },
    async handleColorUrl (color) {
      if (color.indexOf('#') === -1) {
        color = this.hexify(color)
      } else {
        color = color.slice(1)
      }
      if (this.colorList.length === 0) {
        const li = await convertImgToSvg(this.list)
        this.colorList = li
      }
      await this.$nextTick()
      let svgImgs = this.$el.querySelectorAll('.img-color')
      svgImgs = Array.from(svgImgs)
      for (const key in svgImgs) {
        const img = svgImgs[key]
        const svg = img.querySelector('svg')
        svg.querySelectorAll('path').forEach(element => {
          element.setAttribute('fill', '#' + color) // 修改填充色
        })
        const svgStr = svg.outerHTML
        this.colorList[key].url = svgStr
      }
      this.isLoading = false
    },
    async colorChange (value) {
      if (this.isColor && value !== 'default' && !this.custom) {
        await this.handleColorUrl(value)
      } else this.isLoading = false
    }
  },
  watch: {
    activeValue: {
      handler (value) {
        if (value) {
          this.activeImg = value
        }
      },
      immediate: true
    },
    color: {
      handler (value) {
        this.colorChange(value)
      },
      immediate: true
    },
    loading: {
      handler (value) {
        this.isLoading = value
      },
      immediate: true
    },
    isLoading: {
      handler (value) {
        this.$emit('update:loading', value)
      },
      immediate: true
    }
  },
  computed: {
    listComp () {
      if (this.color === 'default' || this.custom || !this.isColor) {
        return this.list
      } else {
        return this.colorList
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.icon-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  &-title {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: rgba(103, 117, 133, 1);
    margin-bottom: 12px;
    padding-right: 24px;
    .upload-edit {
      color: rgba(5, 126, 255, 1);
      cursor: pointer;
      font-weight: 400;
    }
  }
  .upload-title {
    font-weight: 600;
    color: rgba(1, 25, 51, 1);
  }
  &-content {
    display: flex;
    flex-wrap: wrap;
    &-item {
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border: 2px solid rgba(245, 246, 247, 1);
      border-radius: 4px;
      box-sizing: border-box;
      position: relative;
      padding: 6px;
      box-sizing: border-box;
      .el-image {
        width: 100%;
        height: 100%;
      }
      .upload-model {
        background: rgba(1, 25, 51, 0.5);
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        flex-direction: column;
        .upload-tips {
          font-size: 12px;
          color: #fff;
          height: 18px;
          margin-bottom: 3px;
        }
        .el-progress {
          width: 60%;
        }
      }
      .upload-delete {
        width: 16px;
        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(1, 25, 51, 1);
        position: absolute;
        right: -8px;
        top: -8px;
        border-radius: 100%;
        .icon-guanbi {
          font-size: 18px;
          color: #fff;
          transform: scale(0.6);
        }
      }
    }
    .active {
      border-color: rgba(155, 203, 255, 1);
    }
    .iconly {
      width: 55px;
      height: 55px;
      margin-right: 8px;
      margin-bottom: 8px;
    }
    .illustration {
      width: 114px;
      height: 85px;
      margin-bottom: 8px;
      margin-right: 8px;
    }
  }
}
</style>
<style >
.img-color > svg {
  width: 39px;
  height: 39px;
}
</style>